import React, { useState, useRef, useEffect } from 'react';
import { useDisclosure } from "@chakra-ui/react";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Logo from './partials/Logo';
import Button from '../elements/Button';
import SoundOffButton from '../../assets/images/Sound_Off_Button.png';
import SoundOnButton from '../../assets/images/Sound_On_Button.png';
import EduverseLogo from '../../assets/images/EduverseLogo.webp';
import { Connectors } from '../wallets/Connectors';
import { useWeb3React } from "@web3-react/core";
import SelectWalletModal from "./../wallets/WalletModal";

const propTypes = {
  navPosition: PropTypes.string,
  hideNav: PropTypes.bool,
  hideSignin: PropTypes.bool,
  bottomOuterDivider: PropTypes.bool,
  bottomDivider: PropTypes.bool
}

const defaultProps = {
  navPosition: '',
  hideNav: false,
  hideSignin: false,
  bottomOuterDivider: false,
  bottomDivider: false
}

const Header = ({
  className,
  navPosition,
  hideNav,
  hideSignin,
  bottomOuterDivider,
  bottomDivider,
  ...props
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    library,
    chainId,
    account,
    activate,
    deactivate,
    active
  } = useWeb3React();

  const [isActive, setIsactive] = useState(false);
  const [soundButtonImage, setSoundButtonImage] = useState(SoundOnButton);

  const nav = useRef(null);
  const hamburger = useRef(null);

  useEffect(() => {
    isActive && openMenu();
    document.addEventListener('keydown', keyPress);
    document.addEventListener('click', clickOutside);

    // Activate wallet connector
    // const provider = window.localStorage.getItem("provider");
    // if (provider) {
    //   activate(Connectors[provider]);
    // }

    return () => {
      document.removeEventListener('keydown', keyPress);
      document.removeEventListener('click', clickOutside);
      closeMenu();
    };
  });  

  const toggleSound = () => {
    if(document.getElementById("site-sound").classList.contains("muted")){
      document.getElementById("site-sound").classList.remove("muted");
      document.getElementById("site-music-day").classList.remove("muted");
      document.getElementById("site-music-night").classList.remove("muted");
      if(document.querySelector('.form-switch-icon').classList.contains('day')){
        document.getElementById("site-music-day").play();
      }
      else{
        document.getElementById("site-music-night").play();
      }
      setSoundButtonImage(SoundOnButton);
    }
    else{
      document.getElementById("site-sound").classList.add("muted");
      document.getElementById("site-music-day").classList.add("muted");
      document.getElementById("site-music-night").classList.add("muted");
      document.getElementById("site-music-day").pause();
      document.getElementById("site-music-night").pause();
      setSoundButtonImage(SoundOffButton);
    }
  }

  const openMenu = () => {
    document.body.classList.add('off-nav-is-active');
    nav.current.style.maxHeight = nav.current.scrollHeight + 'px';
    setIsactive(true);
  }

  const closeMenu = () => {
    document.body.classList.remove('off-nav-is-active');
    nav.current && (nav.current.style.maxHeight = null);
    setIsactive(false);
  }

  const keyPress = (e) => {
    isActive && e.keyCode === 27 && closeMenu();
  }

  const clickOutside = (e) => {
    if (!nav.current) return
    if (!isActive || nav.current.contains(e.target) || e.target === hamburger.current) return;
    closeMenu();
  }  

  const classes = classNames(
    'site-header',
    bottomOuterDivider && 'has-bottom-divider',
    className
  );

  const clickMenu = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: "smooth"
      });
    }
  }

  const refreshWalletState = () => {
    window.localStorage.setItem("provider", undefined);
    // setNetwork("");
    // setMessage("");
    // setSignature("");
    // setVerified(undefined);
  };

  const disconnectFromWallet = () => {
    console.log("disconnectFromWallet");
    refreshWalletState();
    deactivate();
  };

  return (
    <header
      {...props}
      className={classes}
    >
      <div className="container">
        <div className={
          classNames(
            'site-header-inner',
            bottomDivider && 'has-bottom-divider'
          )}>
          <Link to="/" onClick={closeMenu}>
            <img src={EduverseLogo} alt='EduVerse' onClick={() => {closeMenu(); clickMenu("landing-page");}}/>
          </Link>
          {!hideNav &&
            <>
              <button className="header-nav toggle-sound-button mobile" onClick={toggleSound}>
                <img src={soundButtonImage}/>
              </button>
              <button
                ref={hamburger}
                className="header-nav-toggle"
                onClick={isActive ? closeMenu : openMenu}
              >
                <span className="screen-reader">Menu</span>
                <span className="hamburger">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
              <nav
                ref={nav}
                className={
                  classNames(
                    'header-nav',
                    isActive && 'is-active'
                  )}>
                <div className="header-nav-inner">
                  <ul className={
                    classNames(
                      'list-reset text-xs',
                      navPosition && `header-nav-${navPosition}`,
                      'header-nav-center'
                    )}>
                    <li className="home-button">
                      <Link to="/" onClick={() => {closeMenu(); clickMenu("home");}}>HOME</Link>
                      {/*  Submenu for home page, implement if needed
                        <div className='home-menu'>
                          <ul className="dropdown">
                            <li>
                              <Link to="/" onClick={() => {closeMenu(); clickMenu("manifesto");}}>MANIFESTO</Link>
                            </li>
                            <li>
                              <Link to="/" onClick={() => {closeMenu(); clickMenu("roadmap");}}>MILESTONES</Link>
                            </li>
                            <li>
                              <Link to="/" onClick={() => {closeMenu(); clickMenu("team");}}>TEAM</Link>
                            </li>
                            <li>
                              <Link to="/" onClick={() => {closeMenu(); clickMenu("faqs");}}>FAQs</Link>
                            </li>
                          </ul>
                        </div>
                      */}
                    </li>
                    <li>
                      <Link to="/mint" onClick={closeMenu}>MINT</Link>
                    </li>
                    <li>
                      <Link to="/marketplace" onClick={closeMenu}>MARKETPLACE</Link>
                    </li>
                    <li>
                      <Link to="/game" onClick={closeMenu}>GAME</Link>
                    </li>
                    <li>
                      <Link to="/rewards" onClick={closeMenu}>REWARDS</Link>
                    </li>
                    <li>
                      <Link to="/" onClick={closeMenu} className="header-icon-link">
                        <i className="fa-brands fa-twitter header-icon"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/" onClick={closeMenu} className="header-icon-link">
                        <i className="fa-brands fa-discord header-icon"></i>
                      </Link>
                    </li>
                    {/* 
                    <li>
                        <button className="toggle-sound-button desktop" onClick={toggleSound}>
                          <img src={soundButtonImage}/>
                        </button>
                    </li>
                    */}
                  </ul>
             
                  <ul
                    className="list-reset header-nav-right"
                  >
                    <li>
                      {!active ? (
                        <Button className="button button-primary button-wide-mobile button-sm" onClick={onOpen}>Connect Wallet</Button>
                      ) : (
                        <Button className ="rounded-button" onClick={disconnectFromWallet}>Disconnect</Button>
                      )}
                    </li>
                  </ul>
                </div>
              </nav>
            </>}
        </div>
      </div>
      
      <SelectWalletModal isOpen={isOpen} closeModal={onClose} />
    </header>
  );
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;